import { connect } from 'react-redux';
import {
  loadSavedDocuments,
  receiveStandaloneDraft,
  setShowRestoreDialog
} from '../../redux/actions/rootAction';
import React from 'react';
import { gaeList } from '../requestedDocuments/ga';
import II18 from '../translate/II18';
import { gae, gaeApp } from '../helpers/Analytics';
import PropTypes from 'prop-types';
import { onlyInfoDocuments } from '../helpers/utils';
import { isRequestACrossDeviceDocument } from '../../lib/utils';
import {
  applyStandaloneDraftPendingSourcePdfs,
  getStandaloneDraft,
  getStandaloneDraftForNewSession,
  updateStandaloneDraftPwaSession
} from '../../lib/standaloneDraftCache';

const mapStateToProps = state => ({
  templateRequestPrepared: state.templateRequestPrepared,
  templateMode: state.templateMode,
  scanEnded: state.scanEnded,
  scanStarted: state.scanStarted,
  canSaveDocuments: state.canSaveDocuments,
  showRestoreDialog: state.showRestoreDialog,
  recipientRequestId: state.recipientRequestId,
  requestedDocuments: state.requestedDocuments,
  requestStartInfo: state.requestStartInfo
});

const mapDispatchToProps = dispatch => ({
  loadSavedDocuments: (recipientRequestId, check) =>
    dispatch(loadSavedDocuments(recipientRequestId, check)),

  hideRestoreDialog: () => dispatch(setShowRestoreDialog(false)),

  setShowRestoreDialog: on => dispatch(setShowRestoreDialog(on)),

  receiveStandaloneDraft: draftState =>
    dispatch(receiveStandaloneDraft(draftState))
});

class RestoreSavedDocumentsDialog extends React.Component {
  checkForSavedDocuments = () => {
    if (
      this.props.showRestoreDialog === undefined &&
      this.props.scanStarted &&
      this.props.requestedDocuments &&
      !isRequestACrossDeviceDocument(this.props.requestStartInfo) &&
      !this.props.scanEnded &&
      !this.props.templateMode &&
      !this.props.templateRequestPrepared &&
      this.props.canSaveDocuments &&
      !onlyInfoDocuments(this.props.requestedDocuments)
    ) {
      gaeList('CHECK_FOR_SAVED_DOCUMENTS');
      this.props.loadSavedDocuments(this.props.recipientRequestId, true);
      return;
    }

    this.checkForEmbedDraft();
  };

  checkForEmbedDraft = () => {
    if (
      this._embedDraftCheckStarted ||
      this.props.showRestoreDialog !== undefined ||
      !window.embedDraftEnabled ||
      !this.props.scanStarted ||
      !this.props.templateMode ||
      this.props.templateRequestPrepared ||
      this.props.scanEnded ||
      !this.props.recipientRequestId
    ) {
      return;
    }

    this._embedDraftCheckStarted = true;
    gaeApp('STANDALONE_DRAFT', 'EMBED_CHECK', this.props.recipientRequestId);
    getStandaloneDraftForNewSession().then(draft => {
      if (this.props.showRestoreDialog !== undefined) return;

      const hasDraft =
        draft?.templateId &&
        draft.templateId === this.props.recipientRequestId &&
        draft.state;

      this.props.setShowRestoreDialog(Boolean(hasDraft));
      if (hasDraft) {
        gaeApp('STANDALONE_DRAFT', 'EMBED_PROMPT', draft.templateId);
      }
    });
  };

  loadEmbedDraft = () => {
    const templateId = this.props.recipientRequestId;
    getStandaloneDraft().then(draft => {
      if (!draft?.state || draft.templateId !== templateId) {
        gaeApp('STANDALONE_DRAFT', 'EMBED_RESTORE_MISS', templateId);
        return;
      }
      gaeApp('STANDALONE_DRAFT', 'EMBED_RESTORE', draft.templateId);
      applyStandaloneDraftPendingSourcePdfs(draft.state);
      updateStandaloneDraftPwaSession(draft.templateId);
      this.props.receiveStandaloneDraft(draft.state);
    });
  };

  componentDidMount() {
    this.checkForSavedDocuments();
  }

  componentDidUpdate(prevProps) {
    if (
      (!prevProps.scanStarted && this.props.scanStarted) ||
      (!prevProps.templateMode && this.props.templateMode) ||
      (!prevProps.recipientRequestId && this.props.recipientRequestId)
    ) {
      this.checkForSavedDocuments();
    }

    if (
      prevProps.showRestoreDialog === undefined &&
      this.props.showRestoreDialog === true
    ) {
      const isEmbedDraft = Boolean(window.embedDraftEnabled);
      gae(
        'RESTORE',
        isEmbedDraft
          ? 'RESTORE_EMBED_DRAFT_DIALOG.SHOW'
          : 'RESTORE_SAVED_DOCUMENTS_DIALOG.SHOW'
      );

      setTimeout(
        () =>
          this.$f7.dialog
            .create({
              title: '',
              text: II18.get('list_load_saved_documents'),
              buttons: [
                {
                  text: II18.get('list_load_saved_documents_yes'),
                  onClick: () => {
                    this.props.hideRestoreDialog();
                    if (isEmbedDraft) {
                      this.loadEmbedDraft();
                      gae('RESTORE', 'RESTORE_EMBED_DRAFT_DIALOG.CLOSE');
                      gae('RESTORE', 'LOAD_EMBED_DRAFT', '', true);
                    } else {
                      this.props.loadSavedDocuments(
                        this.props.recipientRequestId
                      );
                      gae('RESTORE', 'RESTORE_SAVED_DOCUMENTS_DIALOG.CLOSE');
                      gae('RESTORE', 'LOAD_SAVED_DOCUMENTS', '', true);
                    }
                  }
                },
                {
                  escapeButton: true,
                  text: II18.get('list_load_saved_documents_no'),
                  onClick: () => {
                    this.props.hideRestoreDialog();
                    if (isEmbedDraft) {
                      gae('RESTORE', 'RESTORE_EMBED_DRAFT_DIALOG.CLOSE');
                      gae('RESTORE', 'DONT_LOAD_EMBED_DRAFT', '', true);
                    } else {
                      gae('RESTORE', 'RESTORE_SAVED_DOCUMENTS_DIALOG.CLOSE');
                      gae('RESTORE', 'DONT_LOAD_SAVED_DOCUMENTS', '', true);
                    }
                  }
                }
              ],
              verticalButtons: true
            })
            .open(),
        500
      );
    }
  }

  render = () => {
    return null;
  };
}

RestoreSavedDocumentsDialog.propTypes = {
  requestStartInfo: PropTypes.object,
  scanEnded: PropTypes.bool,
  scanStarted: PropTypes.any,
  templateMode: PropTypes.bool,
  canSaveDocuments: PropTypes.bool,
  showRestoreDialog: PropTypes.bool,
  templateRequestPrepared: PropTypes.bool,
  hideRestoreDialog: PropTypes.func,
  setShowRestoreDialog: PropTypes.func,
  loadSavedDocuments: PropTypes.func,
  receiveStandaloneDraft: PropTypes.func,
  recipientRequestId: PropTypes.string,
  requestedDocuments: PropTypes.object
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RestoreSavedDocumentsDialog);
